import React from 'react'
import styles from './Loading.module.css'

export const Loading: React.FC = (props: any) => {
  return (
    <div {...props} className={styles.loadingPage}>
      加载更多
  </div>
  )
}